import { Button } from '@planuze/ui';
import { BulkSelectionBar } from '../bulk-selection-bar.js';

interface Props {
  readonly selectedLabel: string;
  readonly actionLabel: string;
  readonly clearLabel: string;
  readonly busy: boolean;
  readonly onApply: () => void;
  readonly onClear: () => void;
}

/** Única operação homogênea do catálogo: takedown das versões exatas selecionadas. */
export function PacksCatalogBulkBar({
  selectedLabel,
  actionLabel,
  clearLabel,
  busy,
  onApply,
  onClear,
}: Props) {
  return (
    <BulkSelectionBar
      selectedLabel={selectedLabel}
      clearLabel={clearLabel}
      busy={busy}
      onClear={onClear}
    >
      <Button size="sm" variant="destructive" disabled={busy} onClick={onApply}>
        {actionLabel}
      </Button>
    </BulkSelectionBar>
  );
}
